import { render, staticRenderFns } from "./MarqueeText.vue?vue&type=template&id=35abce85&scoped=true"
import script from "./MarqueeText.vue?vue&type=script&lang=js"
export * from "./MarqueeText.vue?vue&type=script&lang=js"
import style0 from "./MarqueeText.vue?vue&type=style&index=0&id=35abce85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35abce85",
  null
  
)

export default component.exports